
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './Vocabrawl-webApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
    'kotlinx.coroutines.console_$external_prop_getter' : () => console,
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
    'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
    'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
    'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
              case 'pointercancel':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
    'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
            var text = req.responseText;
            var int8Arr = new Int8Array(text.length);
            for (var i = 0; i < text.length; i++) {
                int8Arr[i] = text.charCodeAt(i) & 0xFF;
            }
            return int8Arr;
        },
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'androidx.navigation.refBrowserWindow' : () => window,
    'androidx.navigation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.navigation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.navigation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.navigation.location_$external_prop_getter' : (_this) => _this.location,
    'androidx.navigation.history_$external_prop_getter' : (_this) => _this.history,
    'androidx.navigation.console_$external_prop_getter' : (_this) => _this.console,
    'androidx.navigation.origin_$external_prop_getter' : (_this) => _this.origin,
    'androidx.navigation.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'androidx.navigation.hash_$external_prop_getter' : (_this) => _this.hash,
    'androidx.navigation.state_$external_prop_getter' : (_this) => _this.state,
    'androidx.navigation.decodeURIComponent_$external_fun' : (p0) => decodeURIComponent(p0),
    'androidx.navigation.state_$external_prop_getter_1' : (_this) => _this.state,
    'androidx.navigation.pushState_$external_fun' : (_this, p0, p1, p2) => _this.pushState(p0, p1, p2),
    'androidx.navigation.replaceState_$external_fun' : (_this, p0, p1, p2) => _this.replaceState(p0, p1, p2),
    'androidx.navigation.addEventListener_$external_fun' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'androidx.navigation.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'androidx.navigation.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'androidx.navigation.encodeURIComponent_$external_fun' : (p0) => encodeURIComponent(p0),
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'neth.iecal.vocabrawl.platform.jsRandomUuid' : () => crypto.randomUUID(),
    'neth.iecal.vocabrawl.platform.jsMonotonic' : () => performance.now(),
    'neth.iecal.vocabrawl.platform.jsEpoch' : () => Date.now(),
    'neth.iecal.vocabrawl.platform.jsIso' : () => new Date().toISOString(),
    'neth.iecal.vocabrawl.platform.jsLocalGet' : (key) => localStorage.getItem(key),
    'neth.iecal.vocabrawl.platform.jsLocalSet' : (key, value) => localStorage.setItem(key, value),
    'neth.iecal.vocabrawl.platform.jsLocalRemove' : (key) => localStorage.removeItem(key),
    'neth.iecal.vocabrawl.platform.jsCourseLanguage' : () => (['ja', 'ko', 'es'].includes(localStorage.getItem('vocabrawl.courseLanguage')) ? localStorage.getItem('vocabrawl.courseLanguage') : 'ja'),
    'neth.iecal.vocabrawl.platform.jsSetCourseLanguage' : (language) => { localStorage.setItem('vocabrawl.courseLanguage', ['ja', 'ko', 'es'].includes(language) ? language : 'ja'); location.reload(); },
    'neth.iecal.vocabrawl.platform.jsPost' : (payload) => {
      const language = (['ja', 'ko', 'es'].includes(localStorage.getItem('vocabrawl.courseLanguage')) ? localStorage.getItem('vocabrawl.courseLanguage') : 'ja');
      const key = 'vocabrawl.pendingEvents' + (language === 'ja' ? '' : '.' + language);
      const legacyKey = language === 'ja' ? 'lingorush.pendingEvents' : '';
      const incoming = JSON.parse(payload).events;
      globalThis.__vocabrawlSendChain = (globalThis.__vocabrawlSendChain || Promise.resolve()).then(async () => {
        let current = incoming;
        try {
          const stored = localStorage.getItem(key) || (legacyKey && localStorage.getItem(legacyKey)) || '[]';
          current = JSON.parse(stored).concat(current);
        } catch (_) {}
        const body = JSON.stringify({events: current});
      const url = globalThis.LANGOWAGE_API_URL || globalThis.LINGORUSH_API_URL || ((location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'http://localhost:8000/api/events' : '/api/events');
        try {
          const response = await fetch(url, {method:'POST', headers:{'Content-Type':'application/json','X-Course-Language':language}, body, keepalive:true});
          if (!response.ok) throw new Error(String(response.status));
          localStorage.removeItem(key);
          if (legacyKey) localStorage.removeItem(legacyKey);
        } catch (_) {
          try { localStorage.setItem(key, JSON.stringify(current.slice(-500))); } catch (_) {}
        }
      });
    },
    'neth.iecal.vocabrawl.platform.jsGameStart' : (anonymousUserId, guestToken, sessionId, rematchOfMatchId) => {
      const game = globalThis.__vocabrawlGame ||= {state:null,serverState:null,startBusy:false,error:null,generation:0,revision:0,clientSequence:0,pending:new Map()};
      const audio = globalThis.__vocabrawlAudio ||= {context:null,buffers:new Map(),pending:new Map(),source:null,effectSource:null,lastPresentation:null,desiredPresentation:null,correctionTimer:null};
      if (!audio.context) {
        try {
          const AudioContext = globalThis.AudioContext || globalThis.webkitAudioContext;
          if (AudioContext) audio.context = new AudioContext();
        } catch (_) {}
      }
      try { audio.context?.resume(); } catch (_) {}
      audio.prepare ||= async (url) => {
        if (!url || !['/audio/tofugu/', '/audio/kokoro/', '/audio/supertonic/', '/audio/sentence/', '/audio/feedback/'].some(prefix => url.startsWith(prefix))) return null;
        if (audio.buffers.has(url)) return audio.buffers.get(url);
        if (!audio.pending.has(url)) {
          audio.pending.set(url, (async () => {
            const configured = globalThis.LANGOWAGE_API_URL || globalThis.LINGORUSH_API_URL;
            const backend = configured ? configured.replace(/\/api\/events\/?$/, '') :
              ((location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'http://localhost:8000' : '');
            const response = await fetch(url.startsWith('/audio/sentence/') ? backend + url : url, {cache:'force-cache'});
            if (!response.ok) throw new Error('Audio HTTP ' + response.status);
            const buffer = await audio.context.decodeAudioData(await response.arrayBuffer());
            audio.buffers.set(url, buffer);
            return buffer;
          })().finally(() => audio.pending.delete(url)));
        }
        return audio.pending.get(url);
      };
      audio.playPronunciation ||= (url, presentation, replay) => {
        const isPronunciation = url && ['/audio/tofugu/', '/audio/kokoro/', '/audio/supertonic/', '/audio/sentence/'].some(prefix => url.startsWith(prefix));
        if (!audio.context || !isPronunciation || !presentation || (!replay && audio.lastPresentation === presentation)) return;
        if (url.startsWith('/audio/sentence/') && !replay && audio.sentenceShown?.get(presentation) !== true) {
          Promise.resolve(audio.prepare(url)).catch(() => {}); return;
        }
        audio.desiredPresentation = presentation;
        audio.lastPresentation = presentation;
        try {
          audio.context.resume();
          audio.source?.stop();
          audio.source = null;
        } catch (_) {}
        const start = buffer => {
          if (!buffer || audio.desiredPresentation !== presentation) return;
          try {
            const source = audio.context.createBufferSource();
            source.buffer = buffer;
            source.connect(audio.context.destination);
            audio.source = source;
            source.start(0);
          } catch (_) {}
        };
        const buffer = audio.buffers.get(url);
        if (buffer) start(buffer); else audio.prepare(url).then(start).catch(() => {});
      };
      audio.playFeedback ||= (correct, correctionUrl, correctionPresentation) => {
        const url = correct ? '/audio/feedback/correct.mp3' : '/audio/feedback/incorrect.mp3';
        const replayCorrection = () => {
          if (!correct && correctionUrl && correctionPresentation) {
            audio.playPronunciation(correctionUrl, correctionPresentation, true);
          }
        };
        if (audio.correctionTimer) clearTimeout(audio.correctionTimer);
        audio.correctionTimer = null;
        const start = buffer => {
          if (!buffer) { replayCorrection(); return; }
          try {
            audio.context.resume();
            if (audio.effectSource) audio.effectSource.onended = null;
            audio.effectSource?.stop();
            const source = audio.context.createBufferSource();
            source.buffer = buffer;
            source.connect(audio.context.destination);
            source.onended = () => {
              if (audio.effectSource === source) audio.effectSource = null;
            };
            audio.effectSource = source;
            source.start(0);
            if (!correct) {
              audio.correctionTimer = setTimeout(() => {
                audio.correctionTimer = null;
                if (audio.effectSource === source) {
                  source.onended = null;
                  try { source.stop(); } catch (_) {}
                  audio.effectSource = null;
                }
                replayCorrection();
              }, 180);
            }
          } catch (_) { replayCorrection(); }
        };
        const buffer = audio.buffers.get(url);
        if (buffer) start(buffer); else audio.prepare(url).then(start).catch(replayCorrection);
      };
      Promise.allSettled([
        audio.prepare('/audio/feedback/correct.mp3'),
        audio.prepare('/audio/feedback/incorrect.mp3')
      ]);
      audio.publish ||= (gameState, state, generation, revision) => {
        const question = state?.current;
        if (gameState.generation !== generation || (revision != null && gameState.revision !== revision)) return false;
        audio.sentenceShown ||= new Map();
        const presentation = question?.attemptToken || question?.questionId;
        if (question?.questionType === 'SENTENCE_MEANING' && presentation && !audio.sentenceShown.has(presentation)) {
          audio.sentenceShown.set(presentation, audio.buffers.has(question.audioUrl));
        }
        gameState.state = state;
        Promise.resolve(audio.prepare(state?.next?.audioUrl)).catch(() => {});
        for (const upcoming of state?.upcoming || []) Promise.resolve(audio.prepare(upcoming?.audioUrl)).catch(() => {});
        Promise.resolve(audio.prepare(question?.audioUrl)).catch(() => {});
        return true;
      };
      const base = () => {
        const configured = globalThis.LANGOWAGE_API_URL || globalThis.LINGORUSH_API_URL;
        if (configured) return configured.replace(/\/api\/events\/?$/, '');
        return (location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'http://localhost:8000' : '';
      };
      const generation = ++game.generation;
      try { game.socket?.close(1000, 'new match'); } catch (_) {}
      if (game.reconnectTimer) clearTimeout(game.reconnectTimer);
      if (game.feedbackAdvanceTimer) clearTimeout(game.feedbackAdvanceTimer);
      game.state = null; game.serverState = null; game.ready = false; game.error = null; game.startBusy = true;
      game.revision = 0; game.clientSequence = 0; game.pending = new Map(); game.reconnectAttempt = 0;
      game.clockSyncId = 0;
      game.feedbackHoldUntil = 0; game.deferredState = null; game.feedbackAdvanceTimer = null;
      game.guestToken = guestToken;
      game.abortStatus = "";
      game.beginRequested = false;
      game.feedback = null;
      audio.lastPresentation = null; audio.desiredPresentation = null; audio.sentenceShown = new Map();
      if (audio.correctionTimer) clearTimeout(audio.correctionTimer);
      audio.correctionTimer = null;
      try { audio.source?.stop(); } catch (_) {}
      if (audio.effectSource) audio.effectSource.onended = null;
      try { audio.effectSource?.stop(); } catch (_) {}
      audio.source = null;
      audio.effectSource = null;
      game.agedRealtimeState = value => {
        const age = Math.max(0, performance.now() - Number(value?.__receivedAtMonotonic || performance.now()));
        return age < 1 ? value : {
          ...value,
          serverEpochMs:Math.round(Number(value.serverEpochMs||Date.now()) + age)
        };
      };
      const presentation = question => question?.attemptToken || question?.questionId || '';
      // Show the last server state with unacknowledged answers replayed on top, so a
      // predicted-correct answer advances and unlocks input without a round trip.
      game.withPendingAnswers = state => {
        let view = state;
        for (const pending of game.pending.values()) {
          if (!view?.current || presentation(view.current) !== presentation(pending.question)) continue;
          if (!pending.predictedCorrect || !view.next) break;
          // The server queues questions beyond `next`, so several quick answers can
          // advance while earlier ones are still in flight.
          const upcoming = Array.isArray(view.upcoming) ? view.upcoming : [];
          view = {...view,
            playerScore:Number(view.playerScore || 0) + 1,
            correctCount:Number(view.correctCount || 0) + 1,
            questionsAttempted:Number(view.questionsAttempted || 0) + 1,
            current:view.next, next:upcoming[0] || null, upcoming:upcoming.slice(1),
            selectedWrongAnswer:null, correctOption:null, lockedUntilEpochMs:0};
        }
        return view;
      };
      game.currentAnswerPending = () => {
        const shown = presentation(game.state?.current);
        if (!shown) return false;
        for (const pending of game.pending.values()) if (presentation(pending.question) === shown) return true;
        return false;
      };
      game.showServerState = state => {
        game.serverState = state;
        return audio.publish(game, game.withPendingAnswers(game.agedRealtimeState(state)), generation, null);
      };
      game.finishFeedbackHold = () => {
        game.feedbackAdvanceTimer = null;
        if (game.generation !== generation) return;
        const deferred = game.deferredState;
        game.deferredState = null;
        if (deferred && Number(deferred.revision||0) >= Number(game.serverState?.revision||0)) {
          game.showServerState(deferred);
        }
      };
      game.publishRealtimeState = state => {
        if (!state || game.generation !== generation) return false;
        const receivedAt = performance.now();
        try { Object.defineProperty(state, '__receivedAtMonotonic', {value:receivedAt, configurable:true}); } catch (_) {}
        const currentPresentation = presentation(game.state?.current);
        const incomingPresentation = presentation(game.withPendingAnswers(state).current);
        const remaining = Number(game.feedbackHoldUntil || 0) - performance.now();
        if (currentPresentation && incomingPresentation &&
            currentPresentation !== incomingPresentation && remaining > 0) {
          if (!game.deferredState || Number(state.revision||0) >= Number(game.deferredState.revision||0)) {
            game.deferredState = state;
          }
          if (!game.feedbackAdvanceTimer) {
            game.feedbackAdvanceTimer = setTimeout(game.finishFeedbackHold, Math.ceil(remaining));
          }
          return true;
        }
        game.showServerState(state);
        return false;
      };
      game.connectRealtime = () => {
        if (!game.beginRequested || game.generation !== generation || !game.state?.matchId || game.socket?.readyState === WebSocket.OPEN || game.socket?.readyState === WebSocket.CONNECTING) return;
        const language = (['ja', 'ko', 'es'].includes(localStorage.getItem('vocabrawl.courseLanguage')) ? localStorage.getItem('vocabrawl.courseLanguage') : 'ja');
        const httpBase = base();
        const socketBase = (httpBase || location.origin).replace(/^http/, 'ws');
        const socket = new WebSocket(socketBase + '/api/game/matches/' + encodeURIComponent(game.state.matchId) + '/realtime?courseLanguage=' + language);
        game.socket = socket;
        game.lastServerSequence = 0;
        socket.onopen = () => {
          if (game.generation !== generation || game.socket !== socket) return socket.close();
          game.reconnectAttempt = 0;
          socket.send(JSON.stringify({type:'hello',guestToken:game.guestToken,resumeFromServerSequence:game.lastServerSequence||0}));
          for (const pending of game.pending.values()) socket.send(JSON.stringify(pending.envelope));
        };
        socket.onmessage = async event => {
          if (game.generation !== generation || game.socket !== socket) return;
          let packet;
          try { packet = JSON.parse(event.data); } catch (_) { return; }
          const serverSequence = Number(packet.serverSequence || 0);
          if (serverSequence && serverSequence <= game.lastServerSequence) return;
          if (serverSequence) game.lastServerSequence = serverSequence;
          if (packet.type === 'sentence_audio_ready' && packet.question?.audioUrl) {
            const ready = packet.question;
            Promise.resolve(audio.prepare(ready.audioUrl)).catch(() => {});
            // Merge only audio fields into the exact presentation. Never publish a
            // stale full question or advance the match when speech finishes.
            for (const state of [game.state, game.deferredState, game.serverState]) {
              for (const question of [state?.current, state?.next, ...(state?.upcoming || [])]) {
                if (question?.sentenceAudioKey === ready.sentenceAudioKey) question.audioUrl = ready.audioUrl;
              }
            }
          } else if (packet.type === 'answer_result') {
            if (packet.state) packet.state.clockSyncId = game.clockSyncId;
            const pending = game.pending.get(packet.messageId);
            game.pending.delete(packet.messageId);
            // Once the player has answered a later question, its feedback owns the slot
            // unless this result contradicts the prediction and rolls the view back.
            if (pending && (game.feedback?.presentationId === presentation(pending.question) ||
                (packet.correct === true) !== pending.predictedCorrect)) {
              game.feedback = {
                presentationId: presentation(pending.question),
                selectedAnswer: pending.answer,
                correctAnswer: packet.correct ? pending.answer : (packet.correctAnswer || ''),
                correct: packet.correct === true,
                targetToken: pending.question?.targetToken || '',
                targetScript: pending.question?.targetScript || pending.question?.targetToken || '',
                correctionAudioUrl: pending.question?.correctionAudioUrl || pending.question?.audioUrl || ''
              };
            }
            game.error = null;
            let heldForFeedback = false;
            if (packet.state && Number(packet.state.revision||0) >= Number(game.serverState?.revision||0)) {
              heldForFeedback = game.publishRealtimeState(packet.state);
            } else if (game.serverState) {
              game.showServerState(game.serverState);
            }
            if (!heldForFeedback) {
              if (game.feedbackAdvanceTimer) clearTimeout(game.feedbackAdvanceTimer);
              game.feedbackAdvanceTimer = null;
              game.deferredState = null;
            }
            if (packet.correct) globalThis.__vocabrawlAuth?.syncAchievements?.();
          } else if (packet.type === 'state' && packet.state) {
            if (packet.resynchronized === true) game.clockSyncId += 1;
            packet.state.clockSyncId = game.clockSyncId;
            const incomingRevision = Number(packet.state.revision || 0);
            const currentRevision = Number(game.serverState?.revision || 0);
            game.ready = true;
            game.startBusy = false;
            // Pending answers are replayed over every server state, so a periodic
            // state serialized before an answer cannot restore the answered question.
            if (incomingRevision >= currentRevision) {
              game.publishRealtimeState(packet.state);
            }
            game.error = null;
          } else if (packet.type === 'error') {
            const failed = packet.messageId ? game.pending.get(packet.messageId) : null;
            if (packet.messageId) game.pending.delete(packet.messageId);
            if (game.feedbackAdvanceTimer) clearTimeout(game.feedbackAdvanceTimer);
            game.feedbackAdvanceTimer = null;
            const latest = game.deferredState || game.serverState;
            game.deferredState = null;
            if (!failed || game.feedback?.presentationId === presentation(failed.question)) game.feedback = null;
            if (latest) game.showServerState(latest);
            game.startBusy = false;
            // An answer sent ahead of an unconfirmed one goes stale when that
            // earlier prediction was wrong; the correction is already on screen.
            if (!failed?.speculative) game.error = String(packet.detail || 'Realtime match error');
          }
        };
        socket.onclose = event => {
          if (game.generation !== generation || game.socket !== socket) return;
          game.socket = null;
          if ((game.state?.status === 'finished' && !game.state.rematchOfferPending) || event.code === 1000) return;
          if (!game.ready) game.startBusy = false;
          const delay = Math.min(5000, 250 * (2 ** Math.min(game.reconnectAttempt++, 5)));
          game.reconnectTimer = setTimeout(game.connectRealtime, delay);
        };
        socket.onerror = () => {
          if (game.generation === generation) {
            game.error = 'Realtime connection interrupted; reconnecting…';
            if (!game.ready) game.startBusy = false;
          }
        };
      };
      (async () => {
        let token = null;
        const auth = globalThis.__vocabrawlAuth;
        if (auth?.state?.status === 'loading' && auth.ready) {
          try { await auth.ready(); } catch (_) {}
        }
        if (auth?.state?.status === 'authenticated' && auth.accessToken) {
          try { token = await auth.accessToken(); } catch (_) {}
        }
        const language = (['ja', 'ko', 'es'].includes(localStorage.getItem('vocabrawl.courseLanguage')) ? localStorage.getItem('vocabrawl.courseLanguage') : 'ja');
        const headers = {'Content-Type':'application/json','X-Guest-Token':guestToken,'X-Course-Language':language};
        if (token) headers.Authorization = 'Bearer ' + token;
        // A friend match the player chose to start; it stays set until a match exists.
        const duelId = rematchOfMatchId ? null : (auth?.duelPlayId?.() || null);
        const response = await fetch(base() + '/api/game/matches', {
          method:'POST', cache:'no-store', headers,
          body:JSON.stringify({anonymousUserId, sessionId, humanSearchElapsedMs:1800,
            ...(rematchOfMatchId ? {rematchOfMatchId} : {}), ...(duelId ? {duelId} : {})})
        });
        if (!response.ok) {
          const detail = (await response.json().catch(()=>null))?.detail || ('HTTP ' + response.status);
          throw new Error(detail);
        }
        const state = await response.json();
        if (duelId) auth?.duelStarted?.(duelId);
        if (game.generation === generation) {
          game.serverState = state;
          audio.publish(game, state, generation, null);
          game.ready = true;
          game.startBusy = false;
        }
      })().catch(error => {
        if (game.generation === generation) {
          game.error = String(error?.message || error);
          game.startBusy = false;
        }
      });
    },
    'neth.iecal.vocabrawl.platform.jsSetMatchBackGuard' : (route) => { globalThis.__vocabrawlMatchBackGuard = route; },
    'neth.iecal.vocabrawl.platform.jsConsumeMatchBack' : () => { const requested = !!globalThis.__vocabrawlMatchBackRequested; globalThis.__vocabrawlMatchBackRequested = false; return requested; },
    'neth.iecal.vocabrawl.platform.jsGameAbort' : () => {
      const game = globalThis.__vocabrawlGame;
      if (!game?.state?.matchId || game.abortStatus === 'pending') return;
      const generation = game.generation;
      const matchId = game.state.matchId;
      const language = localStorage.getItem('vocabrawl.courseLanguage') || 'ja';
      game.abortStatus = 'pending'; game.error = null;
      const configured = globalThis.LANGOWAGE_API_URL || globalThis.LINGORUSH_API_URL;
      const base = configured ? configured.replace(/\/api\/events\/?$/, '') : ((location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'http://localhost:8000' : '');
      (async () => {
        const auth = globalThis.__vocabrawlAuth;
        const headers = {'X-Guest-Token':game.guestToken,'X-Course-Language':language};
        if (auth?.state?.status === 'authenticated') headers.Authorization = 'Bearer ' + await auth.accessToken();
        const response = await fetch(base + '/api/game/matches/' + encodeURIComponent(matchId) + '/abort', {
          method:'POST', cache:'no-store', headers, signal:AbortSignal.timeout(10000)
        });
        if (!response.ok) throw new Error((await response.json().catch(()=>null))?.detail || ('HTTP ' + response.status));
        const body = await response.json();
        if (!body.state || body.state.matchId !== matchId || !body.state.playerAborted) throw new Error('Could not read the abort result. Please retry.');
        if (game.generation === generation) {
          if (game.feedbackAdvanceTimer) clearTimeout(game.feedbackAdvanceTimer);
          game.feedbackAdvanceTimer = null;
          game.deferredState = null; game.feedback = null;
          game.pending = new Map();
          game.state = game.serverState = body.state;
          game.ready = true;
          game.abortStatus = 'success';
          auth?.syncAchievements?.();
          await auth?.refreshMatchRating?.();
        }
      })().catch(error => {
        if (game.generation === generation) { game.abortStatus = 'error'; game.error = String(error.message || error); }
      });
    },
    'neth.iecal.vocabrawl.platform.jsGameAbortStatus' : () => globalThis.__vocabrawlGame?.abortStatus || '',
    'neth.iecal.vocabrawl.platform.jsGameCancel' : () => {
      const game = globalThis.__vocabrawlGame;
      if (!game) return;
      // Backing out of a started friend match tells the friend right away instead
      // of leaving them to play against an empty seat.
      const leaving = game.state?.friendMatch && game.state.status === 'active' ? game.state.matchId : null;
      if (leaving) (async () => {
        const auth = globalThis.__vocabrawlAuth;
        const language = localStorage.getItem('vocabrawl.courseLanguage') || 'ja';
        const headers = {'X-Guest-Token':game.guestToken,'X-Course-Language':language};
        if (auth?.state?.status === 'authenticated') headers.Authorization = 'Bearer ' + await auth.accessToken();
        const configured = globalThis.LANGOWAGE_API_URL || globalThis.LINGORUSH_API_URL;
        const base = configured ? configured.replace(/\/api\/events\/?$/, '') : ((location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'http://localhost:8000' : '');
        await fetch(base + '/api/game/matches/' + encodeURIComponent(leaving) + '/abort', {
          method:'POST', cache:'no-store', keepalive:true, headers
        });
      })().catch(() => {});
      game.generation = Number(game.generation || 0) + 1;
      try { game.socket?.close(1000, 'matchmaking cancelled'); } catch (_) {}
      if (game.reconnectTimer) clearTimeout(game.reconnectTimer);
      if (game.feedbackAdvanceTimer) clearTimeout(game.feedbackAdvanceTimer);
      game.socket = null;
      game.reconnectTimer = null;
      game.feedbackAdvanceTimer = null;
      game.deferredState = null;
      game.pending = new Map();
      game.state = null;
      game.serverState = null;
      game.ready = false;
      game.feedback = null;
      game.error = null;
      game.startBusy = false;
    },
    'neth.iecal.vocabrawl.platform.jsGameBegin' : () => {
      const game = globalThis.__vocabrawlGame;
      if (!game?.state?.matchId || game.beginRequested) return;
      game.beginRequested = true;
      game.startBusy = true;
      game.connectRealtime?.();
    },
    'neth.iecal.vocabrawl.platform.jsGamePoll' : () => {
      const game = globalThis.__vocabrawlGame;
      if (!game?.state?.matchId || (game.state.status === 'finished' && !game.state.rematchOfferPending)) return;
      if (!game.socket || game.socket.readyState > WebSocket.OPEN) game.connectRealtime?.();
    },
    'neth.iecal.vocabrawl.platform.jsGameAnswer' : (questionId, attemptToken, answer, responseTimeMs, answeredAtEpochMs) => {
      const game = globalThis.__vocabrawlGame;
      if (!game?.state?.matchId || game.startBusy || game.currentAnswerPending?.()) return;
      const answeredQuestion = game.state.current;
      game.error = null;
      if (game.feedbackAdvanceTimer) clearTimeout(game.feedbackAdvanceTimer);
      game.feedbackAdvanceTimer = null;
      game.deferredState = null;
      game.feedbackHoldUntil = performance.now() + 140;
      const correctAnswer = String(answeredQuestion?.correctOption || '');
      game.feedback = {
        presentationId: answeredQuestion?.attemptToken || answeredQuestion?.questionId || '',
        selectedAnswer: answer,
        correctAnswer,
        correct: correctAnswer !== '' && answer === correctAnswer,
        targetToken: answeredQuestion?.targetToken || '',
        targetScript: answeredQuestion?.targetScript || answeredQuestion?.targetToken || '',
        correctionAudioUrl: answeredQuestion?.correctionAudioUrl || answeredQuestion?.audioUrl || ''
      };
      const clientSequence = ++game.clientSequence;
      const messageId = crypto.randomUUID();
      const envelope = {type:'answer',messageId,clientSequence,payload:{questionId,attemptToken:attemptToken||null,
        answer,clientResponseTimeMs:Number(responseTimeMs),clientAnsweredAtEpochMs:Number(answeredAtEpochMs)}};
      game.pending.set(messageId, {envelope,question:answeredQuestion,answer,
        predictedCorrect:game.feedback.correct,speculative:game.pending.size > 0});
      if (game.serverState) game.showServerState?.(game.serverState);
      if (game.socket?.readyState === WebSocket.OPEN) game.socket.send(JSON.stringify(envelope));
      else game.connectRealtime?.();
    },
    'neth.iecal.vocabrawl.platform.jsGameSnapshot' : () => {
      const game = globalThis.__vocabrawlGame;
      const s = game?.state;
      if (!s || game?.ready !== true) return '';
      const q = s.current;
      const f = game.feedback;
      const p = s.progressSummary;
      const encodeTipWord = word => [word?.targetToken||'',word?.targetScript||'',word?.meaning||'',word?.mnemonic||''].join('\u001b');
      const encodeReviewWords = words => (words||[]).map(word => [
        word?.conceptId||'',word?.targetToken||'',word?.targetScript||'',word?.meaning||'',
        word?.easySentence||'',word?.mnemonic||'',word?.audioUrl||'',
        (word?.semanticNeighborConceptIds||[]).join('\u001d'),
        (word?.usageScenario||[]).join('\u001d')
      ].join('\u001f')).join('\u001e');
      const encodeMatchingItems = items => (items||[]).map(item => [item?.id||'',item?.text||'',item?.representation||'',item?.audioUrl||''].join('\u001d')).join('\u001c');
      const mnemonicTips = (p?.mnemonicTips||[]).map(tip => [
        encodeTipWord(tip),
        (tip?.nearbyWords||[]).map(encodeTipWord).join('\u001c')
      ].join('\u001d')).join('\u001e');
      return [s.matchId,s.startedAtEpochMs,s.endsAtEpochMs,s.playerScore,s.opponentScore,s.correctCount,
        s.incorrectCount,s.questionsAttempted,s.averageResponseTimeMs,s.status,'','','',q?.questionId||'',
        q?.sentence||'',q?.targetToken||'',(q?.options||[]).join('\u001f'),s.selectedWrongAnswer||'',
        s.correctOption||'',s.lockedUntilEpochMs||0,s.opponentAccuracy,s.opponentMeanResponseMs,q?.attemptToken||'',
        q?.targetScript||q?.targetToken||'',q?.audioUrl||'',f?.presentationId||'',f?.selectedAnswer||'',
        f?.correctAnswer||'',f?.correct?'1':'0',f?.targetToken||'',f?.targetScript||'',
        p?.fasterCount||0,p?.recoveredCount||0,p?.shakyCount||0,p?.fasterExample?.target||'',
        p?.fasterExample?.previousMs||0,p?.fasterExample?.currentMs||0,'',
        q?.isNewWord?'1':'0',mnemonicTips,q?.questionType||'FORWARD',
        encodeMatchingItems(q?.matchingLeft),encodeMatchingItems(q?.matchingRight),
        s.opponentId||'',s.opponentName||'Opponent',s.opponentRating||1000,s.opponentPlayStyle||'',
        f?.correctionAudioUrl||'',encodeReviewWords(p?.incorrectWords),
        encodeReviewWords(p?.newlyIntroducedWords),(q?.highlightTokens||[]).join('\u001d'),
        s.serverEpochMs||Date.now(),q?.correctOption||'',s.clockSyncId||0,s.rematchOffered?'1':'0',s.opponentAvatarSeed||s.opponentId||'legacy',s.opponentThemeId||'default',
        (q?.usageScenario||[]).join('\u001d'),q?.targetRomanization||'',s.opponentAborted?'1':'0',s.playerAborted?'1':'0',s.abortRatingPenalty??'',s.abortRatingAfter??''].join('\t');
    },
    'neth.iecal.vocabrawl.platform.jsGameRequestRematch' : (matchId, guestToken) => {
      const game = globalThis.__vocabrawlGame;
      if (!game || game.state?.matchId !== matchId || (game.rematch?.matchId === matchId && game.rematch?.status === 'pending')) return;
      const generation = game.generation;
      const language = (['ja', 'ko', 'es'].includes(localStorage.getItem('vocabrawl.courseLanguage')) ? localStorage.getItem('vocabrawl.courseLanguage') : 'ja');
      const request = game.rematch = {matchId, status:'pending', error:''};
      const configured = globalThis.LANGOWAGE_API_URL || globalThis.LINGORUSH_API_URL;
      const base = configured ? configured.replace(/\/api\/events\/?$/, '') : ((location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'http://localhost:8000' : '');
      const current = () => game.generation === generation && game.state?.matchId === matchId && game.rematch === request && language === (localStorage.getItem('vocabrawl.courseLanguage') || 'ja');
      (async () => {
        const response = await fetch(base + '/api/game/matches/' + encodeURIComponent(matchId) + '/rematch', {
          method:'POST', cache:'no-store', signal:AbortSignal.timeout(10000),
          headers:{'X-Guest-Token':guestToken,'X-Course-Language':language}
        });
        if (!response.ok) throw new Error((await response.json().catch(()=>null))?.detail || ('HTTP ' + response.status));
        const body = await response.json();
        if (body.matchId !== matchId || !['accepted', 'declined'].includes(body.status)) throw new Error('Could not read the rematch response. Please retry.');
        if (current()) { request.status = body.status; request.error = body.reason === 'opponent_unavailable' ? body.reason : ''; }
      })().catch(error => {
        if (current()) { request.status = 'error'; request.error = String(error?.message || error).replace(/[\t\n]/g, ' '); }
      });
    },
    'neth.iecal.vocabrawl.platform.jsGameRematchSnapshot' : () => {
      const game = globalThis.__vocabrawlGame;
      const request = game?.rematch;
      return request && game.state?.matchId === request.matchId ? [request.matchId, request.status, request.error || ''].join('\t') : '';
    },
    'neth.iecal.vocabrawl.platform.jsLoadDiscoveredWords' : (anonymousUserId, guestToken) => {
      const state = globalThis.__vocabrawlDiscoveredWords ||= {status:'idle',words:[],analytics:'',error:null,generation:0};
      const configured = globalThis.LANGOWAGE_API_URL || globalThis.LINGORUSH_API_URL;
      const base = configured ? configured.replace(/\/api\/events\/?$/, '') : ((location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'http://localhost:8000' : '');
      const generation = ++state.generation;
      state.status = 'loading'; state.error = null; state.analytics = '';
      const language = (['ja', 'ko', 'es'].includes(localStorage.getItem('vocabrawl.courseLanguage')) ? localStorage.getItem('vocabrawl.courseLanguage') : 'ja');
      (async () => {
        let token = null;
        const auth = globalThis.__vocabrawlAuth;
        if (auth?.state?.status === 'loading' && auth.ready) {
          try { await auth.ready(); } catch (_) {}
        }
        if (auth?.state?.status === 'authenticated' && auth.accessToken) {
          try { token = await auth.accessToken(); } catch (_) {}
        }
        const headers = {'X-Guest-Token':guestToken,'X-Course-Language':language};
        if (token) headers.Authorization = 'Bearer ' + token;
        const response = await fetch(base + '/api/learning/discovered-words?includeAnalytics=true&anonymousUserId=' + encodeURIComponent(anonymousUserId), {
          cache:'no-store', headers
        });
        if (!response.ok) throw new Error((await response.json().catch(()=>null))?.detail || ('HTTP ' + response.status));
        const body = await response.json();
        if (state.generation === generation && language === ((['ja', 'ko', 'es'].includes(localStorage.getItem('vocabrawl.courseLanguage')) ? localStorage.getItem('vocabrawl.courseLanguage') : 'ja'))) {
          state.words = Array.isArray(body) ? body : (body.words || []);
          state.analytics = body.analyticsSnapshot || '';
          state.status = 'ready';
        }
      })().catch(error => {
        if (state.generation === generation) {
          state.error = String(error?.message || error);
          state.status = 'error';
        }
      });
    },
    'neth.iecal.vocabrawl.platform.jsQuickLessonsSnapshot' : () => {
      const state = globalThis.__vocabrawlQuickLessons;
      const owner = (globalThis.__vocabrawlAuth?.state?.status || '') + ':' + (globalThis.__vocabrawlAuth?.state?.username || '');
      return state && state.language === (localStorage.getItem('vocabrawl.courseLanguage') || 'ja') && state.owner === owner ? JSON.stringify(state) : '';
    },
    'neth.iecal.vocabrawl.platform.jsPlacementRequest' : (action, payload, anonymousUserId, guestToken) => {
      const state = globalThis.__vocabrawlPlacement ||= {generation:0,status:'idle',info:null,session:null,error:null};
      const language = localStorage.getItem('vocabrawl.courseLanguage') || 'ja';
      const configured = globalThis.LANGOWAGE_API_URL || globalThis.LINGORUSH_API_URL;
      const base = configured ? configured.replace(/\/api\/events\/?$/, '') : ((location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'http://localhost:8000' : '');
      const ownerKey = () => (globalThis.__vocabrawlAuth?.state?.status || '') + ':' + (globalThis.__vocabrawlAuth?.state?.username || '');
      const owner = ownerKey();
      if (state.language !== language || state.owner !== owner) { state.info=null; state.session=null; }
      const generation = ++state.generation;
      state.language=language; state.owner=owner; state.status='loading'; state.error=null;
      if (action === 'load') state.session=null;
      const current = () => state.generation === generation && language === (localStorage.getItem('vocabrawl.courseLanguage') || 'ja') && ownerKey() === owner;
      (async () => {
        const auth = globalThis.__vocabrawlAuth;
        if (auth?.state?.status === 'loading' && auth.ready) await auth.ready();
        const headers = {'X-Guest-Token':guestToken,'X-Course-Language':language};
        if (auth?.state?.status === 'authenticated') {
          const token = await auth.accessToken();
          if (!token) throw new Error('Sign in again to continue');
          headers.Authorization='Bearer '+token;
        }
        const load = action === 'load';
        const path = '/api/learning/placement' + (load ? '?anonymousUserId='+encodeURIComponent(anonymousUserId) : '/'+(action === 'start' || action === 'debug' ? action : 'answer'));
        if (!load) headers['Content-Type']='application/json';
        const response = await fetch(base+path, {method:load ? 'GET' : 'POST',cache:'no-store',headers,
          ...(load ? {} : {body:JSON.stringify({...JSON.parse(payload || '{}'),anonymousUserId})})});
        const result = await response.json();
        if (!response.ok) throw new Error(result?.detail || ('HTTP '+response.status));
        if (!current()) return;
        if (load) state.info=result; else state.session=result;
        if (!load && result.result && state.info) state.info={...state.info,offer:false};
        state.status='ready';
      })().catch(error => { if (current()) { state.status='error'; state.error=String(error?.message || error); } });
    },
    'neth.iecal.vocabrawl.platform.jsPlacementSnapshot' : () => {
      const state = globalThis.__vocabrawlPlacement;
      const owner = (globalThis.__vocabrawlAuth?.state?.status || '') + ':' + (globalThis.__vocabrawlAuth?.state?.username || '');
      return state && state.language === (localStorage.getItem('vocabrawl.courseLanguage') || 'ja') && state.owner === owner ? JSON.stringify(state) : '';
    },
    'neth.iecal.vocabrawl.platform.jsDiscoveredAnalyticsSnapshot' : () => globalThis.__vocabrawlDiscoveredWords?.analytics || '',
    'neth.iecal.vocabrawl.platform.jsDiscoveredWordsSnapshot' : () => (globalThis.__vocabrawlDiscoveredWords?.words || []).map(word => [
      word.conceptId || '', word.targetToken || '', word.targetScript || '', word.meaning || '',
      word.easySentence || '', word.mnemonic || '', word.audioUrl || '',
      (word.semanticNeighborConceptIds || []).join('\u001d'),
      (word.usageScenario || []).join('\u001d'),
      (word.similarLookingKanji || []).map(group => [group.character || '',
        (group.similarCharacters || []).join('')].join('\u001c')).join('\u001d')
    ].join('\u001f')).join('\u001e'),
    'neth.iecal.vocabrawl.platform.jsDiscoveredWordsStatus' : () => globalThis.__vocabrawlDiscoveredWords?.status || 'idle',
    'neth.iecal.vocabrawl.platform.jsDiscoveredWordsError' : () => globalThis.__vocabrawlDiscoveredWords?.error || null,
    'neth.iecal.vocabrawl.platform.jsPlayPronunciation' : (url, presentation, replay) => {
      const audio = globalThis.__vocabrawlAudio ||= {context:null,buffers:new Map(),pending:new Map(),source:null,effectSource:null,lastPresentation:null,desiredPresentation:null,correctionTimer:null};
      if (!audio.context) {
        try {
          const AudioContext = globalThis.AudioContext || globalThis.webkitAudioContext;
          if (AudioContext) audio.context = new AudioContext();
        } catch (_) {}
      }
      try { audio.context?.resume(); } catch (_) {}
      audio.prepare ||= async (audioUrl) => {
        if (!audioUrl || !['/audio/tofugu/', '/audio/kokoro/', '/audio/supertonic/', '/audio/sentence/', '/audio/feedback/'].some(prefix => audioUrl.startsWith(prefix))) return null;
        if (audio.buffers.has(audioUrl)) return audio.buffers.get(audioUrl);
        if (!audio.pending.has(audioUrl)) {
          audio.pending.set(audioUrl, (async () => {
            const configured = globalThis.LANGOWAGE_API_URL || globalThis.LINGORUSH_API_URL;
            const backend = configured ? configured.replace(/\/api\/events\/?$/, '') :
              ((location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'http://localhost:8000' : '');
            const response = await fetch(audioUrl.startsWith('/audio/sentence/') ? backend + audioUrl : audioUrl, {cache:'force-cache'});
            if (!response.ok) throw new Error('Audio HTTP ' + response.status);
            const buffer = await audio.context.decodeAudioData(await response.arrayBuffer());
            audio.buffers.set(audioUrl, buffer);
            return buffer;
          })().finally(() => audio.pending.delete(audioUrl)));
        }
        return audio.pending.get(audioUrl);
      };
      audio.playPronunciation ||= (audioUrl, audioPresentation, audioReplay) => {
        const allowed = audioUrl && ['/audio/tofugu/', '/audio/kokoro/', '/audio/supertonic/', '/audio/sentence/'].some(prefix => audioUrl.startsWith(prefix));
        if (!audio.context || !allowed || !audioPresentation || (!audioReplay && audio.lastPresentation === audioPresentation)) return;
        if (audioUrl.startsWith('/audio/sentence/') && !audioReplay && audio.sentenceShown?.get(audioPresentation) !== true) {
          Promise.resolve(audio.prepare(audioUrl)).catch(() => {}); return;
        }
        audio.desiredPresentation = audioPresentation;
        audio.lastPresentation = audioPresentation;
        try {
          audio.context.resume();
          audio.source?.stop();
          audio.source = null;
        } catch (_) {}
        const start = buffer => {
          if (!buffer || audio.desiredPresentation !== audioPresentation) return;
          try {
            const source = audio.context.createBufferSource();
            source.buffer = buffer;
            source.connect(audio.context.destination);
            audio.source = source;
            source.start(0);
          } catch (_) {}
        };
        const buffer = audio.buffers.get(audioUrl);
        if (buffer) start(buffer); else audio.prepare(audioUrl).then(start).catch(() => {});
      };
      audio.playPronunciation(url, presentation, replay);
    },
    'neth.iecal.vocabrawl.platform.jsStopPronunciation' : () => {
      const audio = globalThis.__vocabrawlAudio;
      if (!audio) return;
      audio.desiredPresentation = null;
      if (audio.correctionTimer) clearTimeout(audio.correctionTimer);
      audio.correctionTimer = null;
      try { audio.source?.stop(); } catch (_) {}
      if (audio.effectSource) audio.effectSource.onended = null;
      try { audio.effectSource?.stop(); } catch (_) {}
      audio.source = null;
      audio.effectSource = null;
    },
    'neth.iecal.vocabrawl.platform.jsAnswerImpact' : (correct, correctionUrl, presentation) => {
      try { navigator.vibrate?.(correct ? 8 : 12); } catch (_) {}
      globalThis.__vocabrawlAudio?.playFeedback?.(correct, correctionUrl, presentation);
    },
    'neth.iecal.vocabrawl.platform.jsPrefersReducedMotion' : () => globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true,
    'neth.iecal.vocabrawl.platform.jsWebAppInstallStatus' : () => globalThis.__vocabrawlInstall?.status() || 'unavailable',
    'neth.iecal.vocabrawl.platform.jsPromptWebAppInstall' : () => globalThis.__vocabrawlInstall?.prompt() === true,
    'neth.iecal.vocabrawl.platform.jsGameBusy' : () => { const g=globalThis.__vocabrawlGame; return g?.startBusy === true || g?.currentAnswerPending?.() === true || Number(g?.state?.lockedUntilEpochMs||0) > Date.now(); },
    'neth.iecal.vocabrawl.platform.jsGameError' : () => globalThis.__vocabrawlGame?.error || null,
    'neth.iecal.vocabrawl.platform.jsAuthStatus' : () => globalThis.__vocabrawlAuth?.state?.status || 'unconfigured',
    'neth.iecal.vocabrawl.platform.jsAuthDisplayName' : () => globalThis.__vocabrawlAuth?.state?.displayName || null,
    'neth.iecal.vocabrawl.platform.jsAuthUsername' : () => globalThis.__vocabrawlAuth?.state?.username || null,
    'neth.iecal.vocabrawl.platform.jsAuthAvatarSeed' : () => globalThis.__vocabrawlAuth?.state?.avatarSeed || null,
    'neth.iecal.vocabrawl.platform.jsAuthProfileHistory' : () => (globalThis.__vocabrawlAuth?.state?.profileHistory || []).map(h => [h.matchId, h.playedAt, h.playerScore, h.opponentScore, h.result, h.opponent||'Opponent', h.ratingBefore ?? '', h.ratingAfter ?? ''].join('\t')).join('\n'),
    'neth.iecal.vocabrawl.platform.jsAuthCurrentStreak' : () => globalThis.__vocabrawlAuth?.state?.profileStreakCurrent || 0,
    'neth.iecal.vocabrawl.platform.jsAuthLongestStreak' : () => globalThis.__vocabrawlAuth?.state?.profileStreakLongest || 0,
    'neth.iecal.vocabrawl.platform.jsAuthRating' : () => globalThis.__vocabrawlAuth?.state?.profileRating ?? 100,
    'neth.iecal.vocabrawl.platform.jsAuthHeartBalance' : () => globalThis.__vocabrawlAuth?.state?.heartBalance ?? -1,
    'neth.iecal.vocabrawl.platform.jsAuthUnlimitedHearts' : () => globalThis.__vocabrawlAuth?.state?.unlimitedHearts === true,
    'neth.iecal.vocabrawl.platform.jsPremiumPortal' : () => { globalThis.__vocabrawlAuth?.premiumPortal?.(); },
    'neth.iecal.vocabrawl.platform.jsPremiumYearlyCheckout' : () => { globalThis.__vocabrawlAuth?.premiumYearlyCheckout?.(); },
    'neth.iecal.vocabrawl.platform.jsPremiumCheckout' : () => { globalThis.__vocabrawlAuth?.premiumCheckout?.(); },
    'neth.iecal.vocabrawl.platform.jsRefreshPremium' : () => { globalThis.__vocabrawlAuth?.refreshPremium?.(); },
    'neth.iecal.vocabrawl.platform.jsPremiumReturnRequested' : () => globalThis.__vocabrawlAuth?.state?.premiumReturnRequested === true,
    'neth.iecal.vocabrawl.platform.jsNewAccountPremiumRequested' : () => globalThis.__vocabrawlAuth?.state?.newAccountPremiumRequested === true,
    'neth.iecal.vocabrawl.platform.jsConsumeNewAccountPremiumRequest' : () => { const state = globalThis.__vocabrawlAuth?.state; if (state) state.newAccountPremiumRequested = false; },
    'neth.iecal.vocabrawl.platform.jsBillingCancelAtPeriodEnd' : () => globalThis.__vocabrawlAuth?.state?.billingCancelAtPeriodEnd === true,
    'neth.iecal.vocabrawl.platform.jsBillingHasSubscription' : () => globalThis.__vocabrawlAuth?.state?.billingHasSubscription === true,
    'neth.iecal.vocabrawl.platform.jsBillingPlan' : () => globalThis.__vocabrawlAuth?.state?.billingPlan || null,
    'neth.iecal.vocabrawl.platform.jsBillingPricing' : () => { const p = globalThis.__vocabrawlAuth?.state?.billingPricing; return p ? [p.currency, p.monthly, p.yearly, p.annualMonthly, p.savings, p.yearlyDiscountPercent, p.yearlyMonthlyEquivalent || ''].join('\t') : null; },
    'neth.iecal.vocabrawl.platform.jsBillingYearlyAvailable' : () => globalThis.__vocabrawlAuth?.state?.billingYearlyAvailable === true,
    'neth.iecal.vocabrawl.platform.jsBillingAvailable' : () => globalThis.__vocabrawlAuth?.state?.billingAvailable === true,
    'neth.iecal.vocabrawl.platform.jsBillingError' : () => globalThis.__vocabrawlAuth?.state?.billingError || null,
    'neth.iecal.vocabrawl.platform.jsBillingStatus' : () => globalThis.__vocabrawlAuth?.state?.billingStatus || 'idle',
    'neth.iecal.vocabrawl.platform.jsAuthCoinBalance' : () => globalThis.__vocabrawlAuth?.state?.coinBalance ?? 0,
    'neth.iecal.vocabrawl.platform.jsAuthStreakFreezers' : () => globalThis.__vocabrawlAuth?.state?.streakFreezers ?? 0,
    'neth.iecal.vocabrawl.platform.jsAuthStreakFreezerPrice' : () => globalThis.__vocabrawlAuth?.state?.streakFreezerPrice ?? 400,
    'neth.iecal.vocabrawl.platform.jsAuthStreakFreezerLimit' : () => globalThis.__vocabrawlAuth?.state?.streakFreezerLimit ?? 2,
    'neth.iecal.vocabrawl.platform.jsStoreStatus' : () => globalThis.__vocabrawlAuth?.state?.storeStatus || 'idle',
    'neth.iecal.vocabrawl.platform.jsStorePurchaseItem' : () => globalThis.__vocabrawlAuth?.state?.storePurchaseItem || null,
    'neth.iecal.vocabrawl.platform.jsStoreError' : () => globalThis.__vocabrawlAuth?.state?.storeError || null,
    'neth.iecal.vocabrawl.platform.jsStoreThemes' : () => (globalThis.__vocabrawlAuth?.state?.themes || []).map(t => [t.id, t.displayPrice, t.owned ? '1' : '0', t.available ? '1' : '0', t.priceCoins ?? ''].join('\t')).join('\n'),
    'neth.iecal.vocabrawl.platform.jsThemeReturnRequested' : () => globalThis.__vocabrawlAuth?.state?.themeReturnRequested === true,
    'neth.iecal.vocabrawl.platform.jsRefreshThemes' : () => { globalThis.__vocabrawlAuth?.refreshThemes?.(); },
    'neth.iecal.vocabrawl.platform.jsBuyTheme' : (id) => { globalThis.__vocabrawlAuth?.buyTheme(id); },
    'neth.iecal.vocabrawl.platform.jsBuyStreakFreezer' : () => { globalThis.__vocabrawlAuth?.buyStreakFreezer(); },
    'neth.iecal.vocabrawl.platform.jsAuthAchievements' : () => (globalThis.__vocabrawlAuth?.state?.achievements || []).map(a => [a.id, a.title, a.progress, a.target, a.reward, a.completed ? '1' : '0'].join('\t')).join('\n'),
    'neth.iecal.vocabrawl.platform.jsAuthProfileStatus' : () => globalThis.__vocabrawlAuth?.state?.profileStatus || 'idle',
    'neth.iecal.vocabrawl.platform.jsAuthProfileError' : () => globalThis.__vocabrawlAuth?.state?.profileError || null,
    'neth.iecal.vocabrawl.platform.jsAuthLogin' : (connection) => { globalThis.__vocabrawlAuth?.login(connection); },
    'neth.iecal.vocabrawl.platform.jsAuthSetUsername' : (username) => { globalThis.__vocabrawlAuth?.updateUsername(username); },
    'neth.iecal.vocabrawl.platform.jsAuthCustomProfilePicture' : () => globalThis.__vocabrawlAuth?.state?.customProfilePicture === true,
    'neth.iecal.vocabrawl.platform.jsAuthChoosePicture' : () => { globalThis.__vocabrawlAuth?.choosePicture(); },
    'neth.iecal.vocabrawl.platform.jsAuthSavePicture' : () => { globalThis.__vocabrawlAuth?.savePicture(); },
    'neth.iecal.vocabrawl.platform.jsAuthCancelPicture' : () => { globalThis.__vocabrawlAuth?.cancelPicture(); },
    'neth.iecal.vocabrawl.platform.jsAuthPicturePreview' : () => globalThis.__vocabrawlAuth?.state?.picturePreview || null,
    'neth.iecal.vocabrawl.platform.jsProfilePictureData' : (seed) => globalThis.__vocabrawlAuth?.pictureData(seed) ?? null,
    'neth.iecal.vocabrawl.platform.jsAuthRegenerateAvatar' : () => { globalThis.__vocabrawlAuth?.regenerateAvatar(); },
    'neth.iecal.vocabrawl.platform.jsAccountDeletionStatus' : () => globalThis.__vocabrawlAuth?.state?.accountDeletionStatus || 'idle',
    'neth.iecal.vocabrawl.platform.jsAccountDeletionError' : () => globalThis.__vocabrawlAuth?.state?.accountDeletionError || null,
    'neth.iecal.vocabrawl.platform.jsDeleteAccount' : () => { globalThis.__vocabrawlAuth?.deleteAccount(); },
    'neth.iecal.vocabrawl.platform.jsAuthLogout' : () => { globalThis.__vocabrawlAuth?.logout(); },
    'neth.iecal.vocabrawl.platform.jsProfileSearchStatus' : () => globalThis.__vocabrawlAuth?.state?.searchStatus || 'idle',
    'neth.iecal.vocabrawl.platform.jsProfileSearchResults' : () => (globalThis.__vocabrawlAuth?.state?.searchResults || []).map(p => p.username + '\t' + p.avatarSeed + '\t' + (p.rating ?? 100)).join('\n'),
    'neth.iecal.vocabrawl.platform.jsProfileSearch' : (query) => { globalThis.__vocabrawlAuth?.searchProfiles(query); },
    'neth.iecal.vocabrawl.platform.jsFriends' : () => (globalThis.__vocabrawlAuth?.state?.friends || []).map(p => p.username + '\t' + p.avatarSeed + '\t' + (p.rating ?? 100) + '\t' + (p.presence || '') + '\t' + (p.lastSeenAtEpochMs ?? '')).join('\n'),
    'neth.iecal.vocabrawl.platform.jsIncomingFriendRequests' : () => (globalThis.__vocabrawlAuth?.state?.incomingFriendRequests || []).map(p => p.username + '\t' + p.avatarSeed + '\t' + (p.rating ?? 100)).join('\n'),
    'neth.iecal.vocabrawl.platform.jsOutgoingFriendRequests' : () => (globalThis.__vocabrawlAuth?.state?.outgoingFriendRequests || []).map(p => p.username + '\t' + p.avatarSeed + '\t' + (p.rating ?? 100)).join('\n'),
    'neth.iecal.vocabrawl.platform.jsFriendStatus' : () => globalThis.__vocabrawlAuth?.state?.friendStatus || 'idle',
    'neth.iecal.vocabrawl.platform.jsFriendError' : () => globalThis.__vocabrawlAuth?.state?.friendError || null,
    'neth.iecal.vocabrawl.platform.jsSendFriendRequest' : (username) => { globalThis.__vocabrawlAuth?.sendFriendRequest(username); },
    'neth.iecal.vocabrawl.platform.jsAcceptFriendRequest' : (username) => { globalThis.__vocabrawlAuth?.acceptFriendRequest(username); },
    'neth.iecal.vocabrawl.platform.jsDeleteFriendRequest' : (username) => { globalThis.__vocabrawlAuth?.deleteFriendRequest(username); },
    'neth.iecal.vocabrawl.platform.jsRemoveFriend' : (username) => { globalThis.__vocabrawlAuth?.removeFriend(username); },
    'neth.iecal.vocabrawl.platform.jsPublicProfileRequestedUsername' : () => globalThis.__vocabrawlAuth?.state?.publicProfileRequestedUsername || null,
    'neth.iecal.vocabrawl.platform.jsPublicProfileStatus' : () => globalThis.__vocabrawlAuth?.state?.publicProfileStatus || 'idle',
    'neth.iecal.vocabrawl.platform.jsPublicProfileUsername' : () => globalThis.__vocabrawlAuth?.state?.publicProfileUsername || null,
    'neth.iecal.vocabrawl.platform.jsPublicProfileAvatarSeed' : () => globalThis.__vocabrawlAuth?.state?.publicProfileAvatarSeed || null,
    'neth.iecal.vocabrawl.platform.jsPublicProfileHistory' : () => (globalThis.__vocabrawlAuth?.state?.publicProfileHistory || []).map(h => [h.matchId, h.playedAt, h.playerScore, h.opponentScore, h.result, h.opponent||'Opponent', h.ratingBefore ?? '', h.ratingAfter ?? ''].join('\t')).join('\n'),
    'neth.iecal.vocabrawl.platform.jsPublicProfileCurrentStreak' : () => globalThis.__vocabrawlAuth?.state?.publicProfileStreakCurrent || 0,
    'neth.iecal.vocabrawl.platform.jsPublicProfileLongestStreak' : () => globalThis.__vocabrawlAuth?.state?.publicProfileStreakLongest || 0,
    'neth.iecal.vocabrawl.platform.jsPublicProfileRating' : () => globalThis.__vocabrawlAuth?.state?.publicProfileRating ?? 100,
    'neth.iecal.vocabrawl.platform.jsPublicProfileFriends' : () => (globalThis.__vocabrawlAuth?.state?.publicProfileFriends || []).map(p => p.username + '\t' + p.avatarSeed + '\t' + (p.rating ?? 100)).join('\n'),
    'neth.iecal.vocabrawl.platform.jsPublicProfileCards' : () => (globalThis.__vocabrawlAuth?.state?.publicProfileCards || []).map(a => [a.id, a.title, a.progress, a.target, a.reward, a.completed ? '1' : '0'].join('\t')).join('\n'),
    'neth.iecal.vocabrawl.platform.jsOpenPublicProfile' : (username) => { globalThis.__vocabrawlAuth?.loadPublicProfile(username); },
    'neth.iecal.vocabrawl.platform.jsLeavePublicProfile' : () => { globalThis.__vocabrawlAuth?.leavePublicProfile(); },
    'neth.iecal.vocabrawl.platform.jsShareProfile' : (username) => { globalThis.__vocabrawlAuth?.shareProfile(username); },
    'neth.iecal.vocabrawl.platform.jsProfileShareStatus' : () => globalThis.__vocabrawlAuth?.state?.shareStatus || 'idle',
    'neth.iecal.vocabrawl.platform.jsDuelInviteId' : () => globalThis.__vocabrawlAuth?.duelInviteId?.() || null,
    'neth.iecal.vocabrawl.platform.jsDuelAction' : (action, target, anonymousUserId, guestToken) => { globalThis.__vocabrawlAuth?.duelAction(action, target, anonymousUserId, guestToken); },
    'neth.iecal.vocabrawl.platform.jsIncomingChallenges' : () => globalThis.__vocabrawlAuth?.incomingChallenges?.() || '',
    'neth.iecal.vocabrawl.platform.jsDuelSnapshot' : () => globalThis.__vocabrawlAuth?.duelSnapshot?.() || '',
    'neth.iecal.vocabrawl.platform.jsShareDuel' : () => { globalThis.__vocabrawlAuth?.shareDuel(); },
    'neth.iecal.vocabrawl.platform.jsSaveAuthenticatedMatch' : (matchId, playedAtEpochMs, playerScore, opponentScore, result, opponent) => { globalThis.__vocabrawlAuth?.saveMatchHistory(matchId, Number(playedAtEpochMs), playerScore, opponentScore, result, opponent); },
    'neth.iecal.vocabrawl.platform.jsSyncAchievements' : (anonymousUserId, guestToken) => { globalThis.__vocabrawlAuth?.syncAchievements(anonymousUserId, guestToken); },
    'neth.iecal.vocabrawl.platform.jsDebug' : () => new URLSearchParams(location.search).get('debug') === 'true',
    'neth.iecal.vocabrawl.platform.jsInstallBeacon' : (userId, sessionId) => {
      addEventListener('pagehide', () => {
        const event = {event:'session_ended', eventId:crypto.randomUUID(), anonymousUserId:userId, sessionId, timestamp:new Date().toISOString(), properties:{}};
        const body = JSON.stringify({events:[event]});
        const baseUrl = globalThis.LANGOWAGE_API_URL || globalThis.LINGORUSH_API_URL || ((location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'http://localhost:8000/api/events' : '/api/events');
        const language = (['ja', 'ko', 'es'].includes(localStorage.getItem('vocabrawl.courseLanguage')) ? localStorage.getItem('vocabrawl.courseLanguage') : 'ja');
        const url = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'courseLanguage=' + language;
        try { navigator.sendBeacon(url, new Blob([body], {type:'application/json'})); } catch (_) { fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body,keepalive:true}).catch(()=>{}); }
      }, {once:true});
    },
    'neth.iecal.vocabrawl.platform.jsReminderStatus' : () => {
      const state = globalThis.__vocabrawlReminders ||= {status: 'loading', publicKey: null};
      if (!state.checked) {
        state.checked = true;
        const ios = /iPad|iPhone|iPod/.test(navigator.userAgent)
          || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        const installed = matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
        if (ios && !installed) state.status = 'ios-install';
        else if (!isSecureContext || !('Notification' in globalThis) || !('serviceWorker' in navigator) || !('PushManager' in globalThis)) state.status = 'unsupported';
        else if (Notification.permission === 'denied') state.status = 'denied';
        else {
          const configured = globalThis.LANGOWAGE_API_URL || globalThis.LINGORUSH_API_URL;
          const base = configured ? configured.replace(/\/api\/events\/?$/, '') : ((location.hostname === 'localhost' || location.hostname === '127.0.0.1') ? 'http://localhost:8000' : '');
          state.base = base;
          fetch(base + '/push/config', {signal: AbortSignal.timeout(10000), headers: {'X-Course-Language': localStorage.getItem('vocabrawl.courseLanguage') === 'ko' ? 'ko' : 'ja'}})
            .then(async response => {
              if (!response.ok) throw new Error(response.status === 503 ? 'unconfigured' : 'error');
              const config = await response.json();
              if (!config.publicKey) throw new Error('unconfigured');
              state.publicKey = config.publicKey;
              // Permission alone is not enough: a browser may have granted it
              // without successfully creating a subscription. Never prompt here.
              const registration = await navigator.serviceWorker.getRegistration('/');
              const subscription = await registration?.pushManager.getSubscription();
              let matchingKey = true;
              if (subscription?.options?.applicationServerKey) {
                const key = state.publicKey.replace(/-/g, '+').replace(/_/g, '/');
                const bytes = Uint8Array.from(atob(key.padEnd(Math.ceil(key.length / 4) * 4, '=')), char => char.charCodeAt(0));
                const existingKey = new Uint8Array(subscription.options.applicationServerKey);
                matchingKey = existingKey.length === bytes.length && existingKey.every((value, index) => value === bytes[index]);
              }
              if (Notification.permission === 'granted' && subscription && matchingKey) {
                const auth = globalThis.__vocabrawlAuth;
                await auth.ready();
                // An existing browser subscription may still be anonymous on the
                // server. Confirm the account link before hiding its setup action.
                if (auth.state.status === 'authenticated' && auth.state.pushSubscriptionStatus !== 'enabled') {
                  await auth.uploadPushSubscription(subscription);
                }
                state.status = auth.state.status === 'authenticated' ? 'enabled' : 'sign-in-required';
              } else state.status = 'available';
            })
            .catch(error => { state.status = error.message === 'unconfigured' ? 'unconfigured' : 'error'; });
        }
      }
      if (state.status === 'enabled' && globalThis.__vocabrawlAuth?.state.status === 'authenticated'
        && globalThis.__vocabrawlAuth.state.pushSubscriptionStatus === 'error') state.status = 'error';
      if (['available', 'enabled'].includes(state.status) && Notification.permission === 'denied') state.status = 'denied';
      else if ((state.status === 'denied' && Notification.permission !== 'denied')
        || (state.status === 'enabled' && Notification.permission !== 'granted')) {
        state.checked = false;
        state.status = 'loading';
      }
      return state.status;
    },
    'neth.iecal.vocabrawl.platform.jsEnableReminders' : () => {
      const state = globalThis.__vocabrawlReminders;
      if (!state) return;
      if (state.status === 'error' && !state.publicKey) {
        state.checked = false;
        state.status = 'loading';
        return;
      }
      if (globalThis.__vocabrawlAuth?.state.status !== 'authenticated') {
        state.status = 'sign-in-required';
        return;
      }
      if (!state.publicKey || !['available', 'error', 'push-service-error', 'sign-in-required'].includes(state.status)) return;
      // Invoke the permission prompt directly in the click stack, before any await.
      let permission;
      try {
        permission = Notification.permission === 'granted'
          ? Promise.resolve('granted') : Notification.requestPermission();
      } catch (error) {
        console.warn('Could not request notification permission', error);
        state.status = 'error';
        return;
      }
      state.status = 'working';
      void (async () => {
        try {
          if (await permission !== 'granted') {
            state.status = Notification.permission === 'denied' ? 'denied' : 'available';
            return;
          }
          await navigator.serviceWorker.register('/sw.js', {scope: '/'});
          const registration = await navigator.serviceWorker.ready;
          const key = state.publicKey.replace(/-/g, '+').replace(/_/g, '/');
          const bytes = Uint8Array.from(atob(key.padEnd(Math.ceil(key.length / 4) * 4, '=')), char => char.charCodeAt(0));
          let subscription = await registration.pushManager.getSubscription();
          if (subscription?.options?.applicationServerKey) {
            const existingKey = new Uint8Array(subscription.options.applicationServerKey);
            if (existingKey.length !== bytes.length || existingKey.some((value, index) => value !== bytes[index])) {
              await subscription.unsubscribe();
              subscription = null;
            }
          }
          subscription ||= await registration.pushManager.subscribe({userVisibleOnly: true, applicationServerKey: bytes});
          const json = subscription.toJSON();
          if (!json.endpoint || !json.keys?.p256dh || !json.keys?.auth) throw new Error('Invalid push subscription');
          const auth = globalThis.__vocabrawlAuth;
          await auth.ready();
          await auth.uploadPushSubscription(subscription);
          state.status = 'enabled';
        } catch (error) {
          console.warn('Could not enable reminders', error);
          state.status = error?.name === 'AbortError' && /push service error/i.test(error.message || '')
            ? 'push-service-error' : 'error';
        }
      })();
    },
    'neth.iecal.vocabrawl.platform.jsPlayDeepLinkRequested' : () => location.pathname === '/play',
    'neth.iecal.vocabrawl.ui.theme.setPaintedWorldActive' : (active, animated) => globalThis.__langowagePaintedWorld?.setActive(active, animated),
    'neth.iecal.vocabrawl.finishBootScreen' : () => globalThis.__vocabrawlBootReady ? globalThis.__vocabrawlBootReady() : document.getElementById('boot')?.remove(),
    'neth.iecal.vocabrawl.browserUrlForRoute' : (route) => {
      const params = new URLSearchParams(location.search);
      params.delete('code');
      params.delete('state');
      params.delete('error');
      params.delete('error_description');
      params.delete('error_uri');
      params.delete('iss');
      params.delete('invite');
      // Auth captured these return markers at startup and verifies payment separately.
      // Do not carry them into subsequent app history entries or reloads.
      params.delete('theme');
      params.delete('course_language');
      params.delete('premium');
      // A friend-match invite only applies to its lobby; never re-open it on reload elsewhere.
      if (route !== 'friend-match') params.delete('duel');
      if (route === 'public-profile') {
        const username = globalThis.__vocabrawlAuth?.state?.publicProfileRequestedUsername;
        const language = globalThis.__vocabrawlAuth?.state?.publicProfileLanguage;
        if (username) params.set('profile', username);
        if (username && language) params.set('profile_language', language);
      } else {
        params.delete('profile');
        params.delete('profile_language');
      }
      const query = params.toString();
      return query ? '?' + query : '';
    },
    'neth.iecal.vocabrawl.installMatchBackGuard' : () => {
      let currentState = history.state;
      let currentUrl = location.href;
      const push = history.pushState.bind(history);
      const replace = history.replaceState.bind(history);
      history.pushState = (...args) => { push(...args); currentState = history.state; currentUrl = location.href; };
      history.replaceState = (...args) => { replace(...args); currentState = history.state; currentUrl = location.href; };
      window.addEventListener('popstate', event => {
        if (['battle', 'result', 'searching', 'match-found'].includes(globalThis.__vocabrawlMatchBackGuard)) {
          event.stopImmediatePropagation();
          push(currentState, '', currentUrl);
          globalThis.__vocabrawlMatchBackRequested = true;
        } else { currentState = history.state; currentUrl = location.href; }
      }, true);
    }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    